import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import styles from './Card.module.css';

export type CardPadding = 'sm' | 'md' | 'lg';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: CardPadding;
  children?: ReactNode;
  style?: CSSProperties;
}

const PAD_CLASS: Record<CardPadding, string> = {
  sm: styles.padSm,
  md: styles.padMd,
  lg: styles.padLg,
};

export function Card({ padding = 'md', className, children, ...rest }: CardProps) {
  const classes = [styles.card, PAD_CLASS[padding], className ?? ''].filter(Boolean).join(' ');
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
